var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpiralFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24_2800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -2,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00732422,
    y: -1.13379,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24_2800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_24_2800",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 25,
    height: 25
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.686523,
    y: -0.962891,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_24_2800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6865 13.0371C13.2365 13.0371 13.7074 12.8413 14.099 12.4496C14.4907 12.0579 14.6865 11.5871 14.6865 11.0371C14.6865 10.4871 14.4907 10.0163 14.099 9.62461C13.7074 9.23294 13.2365 9.03711 12.6865 9.03711C12.1365 9.03711 11.6657 9.23294 11.274 9.62461C10.8824 10.0163 10.6865 10.4871 10.6865 11.0371C10.6865 11.5871 10.8824 12.0579 11.274 12.4496C11.6657 12.8413 12.1365 13.0371 12.6865 13.0371ZM17.2115 21.0371C17.5115 20.1038 17.7365 19.2704 17.8865 18.5371C18.0365 17.8038 18.1532 17.2204 18.2365 16.7871C17.5199 17.4871 16.6865 18.0371 15.7365 18.4371C14.7865 18.8371 13.7699 19.0371 12.6865 19.0371C10.4199 19.0371 8.43236 18.8829 6.72402 18.5746C5.01569 18.2663 3.66986 17.9704 2.68652 17.6871V15.5621C3.61986 15.8621 4.45319 16.0871 5.18652 16.2371C5.91986 16.3871 6.50319 16.5038 6.93652 16.5871C6.23652 15.8704 5.68652 15.0371 5.28652 14.0871C4.88652 13.1371 4.68652 12.1204 4.68652 11.0371C4.68652 8.75378 4.84069 6.76211 5.14902 5.06211C5.45736 3.36211 5.75319 2.02044 6.03652 1.03711H8.16152C7.86152 1.97044 7.63236 2.80378 7.47402 3.53711C7.31569 4.27044 7.20319 4.85378 7.13652 5.28711C7.85319 4.58711 8.68652 4.03711 9.63652 3.63711C10.5865 3.23711 11.6032 3.03711 12.6865 3.03711C14.9699 3.03711 16.9615 3.19128 18.6615 3.49961C20.3615 3.80794 21.7032 4.10378 22.6865 4.38711V6.51211C21.7532 6.21211 20.9199 5.98294 20.1865 5.82461C19.4532 5.66628 18.8699 5.55378 18.4365 5.48711C19.1365 6.20378 19.6865 7.03711 20.0865 7.98711C20.4865 8.93711 20.6865 9.95378 20.6865 11.0371C20.6865 13.3204 20.5324 15.3121 20.224 17.0121C19.9157 18.7121 19.6199 20.0538 19.3365 21.0371H17.2115Z",
    fill: "#4D2481"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiralFilled);
export default __webpack_public_path__ + "static/media/spiral-filled.c51689596416e7ee0dfa7087efbea727.svg";
export { ForwardRef as ReactComponent };